export enum Networks {
  WTG = 16,
  GEO = 46
}
